import { Tabs, TabsProps } from 'antd';
import authService from 'core/services/auth';
import { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const BoardsMainListPage: FunctionComponent = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();

	const tabItems: TabsProps['items'] = [
		authService.isPermittedToAction('Board') && {
			id: '1',
			key: '',
			label: t('ACTIONS.BOARD_STRUCTURE'),
			destroyInactiveTabPane: true,
		},
		authService.isPermittedToAction('BoardMeeting') && {
			id: '2',
			key: 'meetings',
			label: t('ACTIONS.BOARD_MEETINGS'),
			destroyInactiveTabPane: true,
		},
		authService.isPermittedToAction('Board') && {
			id: '3',
			key: 'documents',
			label: t('ACTIONS.BOARD_DOCUMENTS'),
			destroyInactiveTabPane: true,
		},
	].filter(Boolean) as TabsProps['items'];

	const getActiveTab = () => {
		const activeTab = tabItems?.find(
			(tab) => tab.key === (location.pathname.includes('meetings') ? 'meetings' : location.pathname.includes('documents') ? 'documents' : ''),
		);
		if (activeTab) return activeTab?.key;
	};

	useEffect(() => {
		if (!getActiveTab() && tabItems?.length! > 0) {
			navigate(`/dashboard/actions/boards/${tabItems![0]?.key}`);
		}
	}, []);

	return (
		<>
			<Tabs activeKey={getActiveTab()} items={tabItems} size="large" onTabClick={(key) => navigate(`/dashboard/actions/boards/${key}`)} />

			<Outlet />
		</>
	);
};

export default BoardsMainListPage;
